import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation SendPrescription($params: PrescriptionInput!) {
    sendPrescription(params: $params) {
      success
    }
  }
`;

export interface PrescriptionParams {
  documentId: string;
  monitorModel: string;
  machineryModel: string;
  observations?: string;
  lineDistance: string;
  channel1Type?: string;
  channel2Type?: string;
  channel3Type?: string;
  records: PrescriptionRecord[];
}

export type PrescriptionResult = {
  success: boolean;
};

interface Renders {
  execute: (params: PrescriptionParams) => void;
  processing: boolean;
}

type ChildrenFn = (renders: Renders) => React.ReactNode;

interface Props {
  onCompleted: (result: PrescriptionResult) => void;
  onError?: (error: any) => void;
  children: ChildrenFn;
}

const PrescriptionProvider: React.StatelessComponent<Props> = (
  props: Props
) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={data => props.onCompleted(data.prescription)}
      onError={props.onError}
    >
      {(mutateFn, result) =>
        props.children({
          processing: result.loading,
          execute: params => mutateFn({ variables: { params } })
        })
      }
    </AuthorizedMutation>
  );
};

export default PrescriptionProvider;



// WEBPACK FOOTER //
// ./src/providers/PrescriptionProvider.tsx